import React from 'react';
import {Link} from "react-router-dom";

const Nav = () => {
    return (
        <ul className="mainmenu">
              <li><Link to="/">Home</Link></li>
            <li><a href="/#servicios">Servicios</a></li>
            <li><Link to="/contacto">Contacto</Link></li>


        </ul>
    )
}
export default Nav;
